import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".MultiselectCardGroup-module_multiselectCardGroup__SqSoM {\n  display: flex;\n  flex-direction: column;\n}\n.MultiselectCardGroup-module_multiselectCardGroup__SqSoM > label:not(:last-child) {\n  margin-bottom: 16px;\n}";
var styles = {"multiselectCardGroup":"MultiselectCardGroup-module_multiselectCardGroup__SqSoM"};
styleInject(css_248z);

export { styles as default };
